import { languageGlobal } from "./GlobalVariableConfig";

export const getManifestMobile = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    // {
                    //     alias: 'volatilityBase',
                    //     src: 'assets/mobile/intro/vol_base.webp',
                    // },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/mobile/2_intro/volatility_on.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/mobile/2_intro/volatility_off.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'intro_bg',
                        src: 'assets/mobile/2_intro/intro_bg.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'textBase',
                        src: 'assets/mobile/2_intro/ticket.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'image1',
                        src: 'assets/mobile/2_intro/image_1.png',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'image2',
                        src: 'assets/mobile/2_intro/image_2.png',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'image3',
                        src: 'assets/mobile/2_intro/image_3.png',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // {
                    //     alias: 'continueBase',
                    //     src: './intro/click_base.webp',
                    // },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/mobile/13_sound/gameloading/Intro_appear.mp3',
                    // },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/mobile/9_bigwin/es/wins.skel' : 'assets/mobile/9_bigwin/wins.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/mobile/9_bigwin/es/wins.atlas' : 'assets/mobile/9_bigwin/wins.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/mobile/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'background',
                        src: 'assets/mobile/6_basegame/base_bg.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'backgroundFree',
                        src: 'assets/mobile/8_freegame/free_bg.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // // reels back
                    {
                        alias: 'reelBackSkel',
                        src: 'assets/mobile/10_reel/basegame_reel/basegame_reel.skel',
                    },
                    {
                        alias: 'reelBackAtlas',
                        src: 'assets/mobile/10_reel/basegame_reel/basegame_reel.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'reelBackSkelFree',
                        src: 'assets/mobile/10_reel/freegame_reel/freegame_reel.skel',
                    },
                    {
                        alias: 'reelBackAtlasFree',
                        src: 'assets/mobile/10_reel/freegame_reel/freegame_reel.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },

                    // Game Intro animation *********************
                    {
                        alias: 'gameIntroSkel',
                        src: 'assets/mobile/3_game_intro/game_intro.skel',
                    },
                    {
                        alias: 'gameIntroAtlas',
                        src: 'assets/mobile/3_game_intro/game_intro.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/mobile/4_logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/mobile/4_logo/logo.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //meter
                    {
                        alias: 'meter_lv1_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv1_active/lv1_active.skel',
                    },
                    {
                        alias: 'meter_lv1_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv1_active/lv1_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_lv2_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv2_active/lv2_active.skel',
                    },
                    {
                        alias: 'meter_lv2_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv2_active/lv2_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_lv3_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv3_active/lv3_active.skel',
                    },
                    {
                        alias: 'meter_lv3_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv3_active/lv3_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_lv4_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv4_active/lv4_active.skel',
                    },
                    {
                        alias: 'meter_lv4_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv4_active/lv4_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_lv5_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv5_active/lv5_active.skel',
                    },
                    {
                        alias: 'meter_lv5_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/lv5_active/lv5_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_hv1_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv1_active/hv1_active.skel',
                    },
                    {
                        alias: 'meter_hv1_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv1_active/hv1_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_hv2_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv2_active/hv2_active.skel',
                    },
                    {
                        alias: 'meter_hv2_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv2_active/hv2_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_hv3_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv3_active/hv3_active.skel',
                    },
                    {
                        alias: 'meter_hv3_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv3_active/hv3_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_hv4_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv4_active/hv4_active.skel',
                    },
                    {
                        alias: 'meter_hv4_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv4_active/hv4_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'meter_hv5_skel',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv5_active/hv5_active.skel',
                    },
                    {
                        alias: 'meter_hv5_atlas',
                        src: 'assets/mobile/14_feature/bottom_active_symbols/hv5_active/hv5_active.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //frame
                    {
                        alias: 'frameSkel',
                        src: 'assets/mobile/14_feature/win_frame/win_frame.skel',
                    },
                    {
                        alias: 'frameAtlas',
                        src: 'assets/mobile/14_feature/win_frame/win_frame.atlas',
                    },
                    //feature trigger text
                    {
                        alias: 'featureTriggerTextSkel',
                        src: 'assets/mobile/14_feature/feature_text/feature_text.skel',
                    },
                    {
                        alias: 'featureTriggerTextAtlas',
                        src: 'assets/mobile/14_feature/feature_text/feature_text.atlas',
                    },
                    //banner *********************
                    // {
                    //     alias: 'banner',
                    //     src: 'assets/mobile/7_banner/intro_outro_base.webp',
                    // },
                    //banner
                    // {
                    //     alias: 'freegame_intro_bg',
                    //     src: 'assets/mobile/7_banner/intro_outro_bg.webp',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    {
                        alias: 'freegame_intro_outro_atlas',
                        src: 'assets/mobile/7_banner/intro_outro.atlas',
                    },
                    {
                        alias: 'freegame_intro_outro_skel',
                        src: 'assets/mobile/7_banner/intro_outro.skel',
                    },
                    // {
                    //     alias: 'banner_mid_static',
                    //     src: 'assets/mobile/7_banner/banner_mid_static.webp',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    //banner-left-char
                    // {
                    //     alias: 'bannerCharLeftSkel',
                    //     src: 'assets/mobile/7_banner/L/intro_rat.skel',
                    // },
                    // {
                    //     alias: 'bannerCharLeftAtlas',
                    //     src: 'assets/mobile/7_banner/L/intro_rat.atlas',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    //banner-right-char
                    // {
                    //     alias: 'bannerCharRightSkel',
                    //     src: 'assets/mobile/7_banner/R/intro_cat.skel',
                    // },
                    // {
                    //     alias: 'bannerCharRightAtlas',
                    //     src: 'assets/mobile/7_banner/R/intro_cat.atlas',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/mobile/6_basegame/baseBgAnimation/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/mobile/6_basegame/baseBgAnimation/basegame.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },

                    //free game background animation
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/mobile/8_freegame/freeBgAnimation/freegame.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/mobile/8_freegame/freeBgAnimation/freegame.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },

                    //free game transition
                    {
                        alias: 'transitionSkel',
                        src: 'assets/mobile/base/transition/transition.skel',
                    },
                    {
                        alias: 'transitionAtlas',
                        src: 'assets/mobile/base/transition/transition.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },

                    //symbols *********************
                    {
                        alias: 'goldCoinSkel',
                        src: 'assets/mobile/12_symbols/gold_coin/gold_coin.skel',
                    },
                    {
                        alias: 'goldCoinAtlas',
                        src: 'assets/mobile/12_symbols/gold_coin/gold_coin.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/mobile/12_symbols/hv1/hv_1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/mobile/12_symbols/hv1/hv_1.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv1Static',
                        src: 'assets/mobile/12_symbols/hv1/hv_1Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv1Blur',
                        src: 'assets/mobile/12_symbols/hv1/hv_1Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/mobile/12_symbols/hv2/hv_2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/mobile/12_symbols/hv2/hv_2.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv2Static',
                        src: 'assets/mobile/12_symbols/hv2/hv_2Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv2Blur',
                        src: 'assets/mobile/12_symbols/hv2/hv_2Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/mobile/12_symbols/hv3/hv_3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/mobile/12_symbols/hv3/hv_3.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv3Static',
                        src: 'assets/mobile/12_symbols/hv3/hv_3Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv3Blur',
                        src: 'assets/mobile/12_symbols/hv3/hv_3Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/mobile/12_symbols/hv4/hv_4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/mobile/12_symbols/hv4/hv_4.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv4Static',
                        src: 'assets/mobile/12_symbols/hv4/hv_4Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv4Blur',
                        src: 'assets/mobile/12_symbols/hv4/hv_4Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // hv5
                    {
                        alias: 'hv5Skel',
                        src: 'assets/mobile/12_symbols/hv5/hv_5.skel',
                    },
                    {
                        alias: 'hv5Atlas',
                        src: 'assets/mobile/12_symbols/hv5/hv_5.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv5Static',
                        src: 'assets/mobile/12_symbols/hv5/hv_5Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv5Blur',
                        src: 'assets/mobile/12_symbols/hv5/hv_5Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/mobile/12_symbols/lv1/lv_1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/mobile/12_symbols/lv1/lv_1.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv1Static',
                        src: 'assets/mobile/12_symbols/lv1/lv_1Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv1Blur',
                        src: 'assets/mobile/12_symbols/lv1/lv_1Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/mobile/12_symbols/lv2/lv_2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/mobile/12_symbols/lv2/lv_2.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv2Static',
                        src: 'assets/mobile/12_symbols/lv2/lv_2Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv2Blur',
                        src: 'assets/mobile/12_symbols/lv2/lv_2Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/mobile/12_symbols/lv3/lv_3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/mobile/12_symbols/lv3/lv_3.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv3Static',
                        src: 'assets/mobile/12_symbols/lv3/lv_3Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv3Blur',
                        src: 'assets/mobile/12_symbols/lv3/lv_3Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/mobile/12_symbols/lv4/lv_4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/mobile/12_symbols/lv4/lv_4.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv4Static',
                        src: 'assets/mobile/12_symbols/lv4/lv_4Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv4Blur',
                        src: 'assets/mobile/12_symbols/lv4/lv_4Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv5
                    {
                        alias: 'lv5Skel',
                        src: 'assets/mobile/12_symbols/lv5/lv_5.skel',
                    },
                    {
                        alias: 'lv5Atlas',
                        src: 'assets/mobile/12_symbols/lv5/lv_5.atlas',
                    },
                    {
                        alias: 'lv5Static',
                        src: 'assets/mobile/12_symbols/lv5/lv_5Static.webp',
                    },
                    {
                        alias: 'lv5Blur',
                        src: 'assets/mobile/12_symbols/lv5/lv_5Blur.webp',
                    },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/mobile/12_symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/mobile/12_symbols/scatter/scatter.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'scatterStatic',
                        src: 'assets/mobile/12_symbols/scatter/scatterStatic.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'scatterBlur',
                        src: 'assets/mobile/12_symbols/scatter/scatterBlur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/mobile/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/mobile/12_symbols/wild/wild.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'wildStatic',
                        src: 'assets/mobile/12_symbols/wild/wildStatic.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'wildBlur',
                        src: 'assets/mobile/12_symbols/wild/wildBlur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //special_symbol
                    {
                        alias: 'specialSymbolSkel',
                        src: 'assets/mobile/12_symbols/special_symbol/special_symbol.skel',
                    },
                    {
                        alias: 'specialSymbolAtlas',
                        src: 'assets/mobile/12_symbols/special_symbol/special_symbol.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'specialSymbolStatic',
                        src: 'assets/mobile/12_symbols/special_symbol/special_symbolStatic.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'specialSymbolBlur',
                        src: 'assets/mobile/12_symbols/special_symbol/special_symbolBlur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // Special Symbols feture animations
                    // 1. Double
                    {
                        alias: 'doubleSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/double/double.skel',
                    },
                    {
                        alias: 'doubleAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/double/double.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // 2. Multi
                    {
                        alias: 'multiSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/multi/multi.skel',
                    },
                    {
                        alias: 'multiAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/multi/multi.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // 3. Extra
                    {
                        alias: 'extraSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/extra/extra.skel',
                    },
                    {
                        alias: 'extraAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/extra/extra.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // 4. double+multi
                    {
                        alias: 'doubleMultiSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/double_multi/double_multi.skel',
                    },
                    {
                        alias: 'doubleMultiAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/double_multi/double_multi.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // 5. double+extra
                    {
                        alias: 'doubleExtraSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/double_extra/double_extra.skel',
                    },
                    {
                        alias: 'doubleExtraAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/double_extra/double_extra.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // 6. multi+extra
                    {
                        alias: 'multiExtraSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/multi_extra/multi_extra.skel',
                    },
                    {
                        alias: 'multiExtraAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/multi_extra/multi_extra.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // 7. double+multi+extra
                    {
                        alias: 'doubleMultiExtraSkel',
                        src: 'assets/mobile/12_symbols/rip_symbols/double_multi_extra/double_multi_extra.skel',
                    },
                    {
                        alias: 'doubleMultiExtraAtlas',
                        src: 'assets/mobile/12_symbols/rip_symbols/double_multi_extra/double_multi_extra.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // paylines animation
                    {
                        alias: 'winLineSkel',
                        src: 'assets/mobile/payline/payline.skel',
                    },
                    {
                        alias: 'winLineAtlas',
                        src: 'assets/mobile/payline/payline.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/mobile/anticipation/anticipation.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/mobile/anticipation/anticipation.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //collect meter
                    {
                        alias: 'collectMeterSkel',
                        src: 'assets/mobile/14_feature/collect_meter/collect_meter.skel',
                    },
                    {
                        alias: 'collectMeterAtlas',
                        src: 'assets/mobile/14_feature/collect_meter/collect_meter.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // Feature Trail
                    {
                        alias: 'featureTrailSkel',
                        src: 'assets/mobile/14_feature/feature_trail/trail.skel',
                    },
                    {
                        alias: 'featureTrailAtlas',
                        src: 'assets/mobile/14_feature/feature_trail/trail.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // Feature Skull impact
                    {
                        alias: 'featureSkullImpactSkel',
                        src: 'assets/mobile/14_feature/skull_impact/skull_impact.skel',
                    },
                    {
                        alias: 'featureSkullImpactAtlas',
                        src: 'assets/mobile/14_feature/skull_impact/skull_impact.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //Transition animation
                    {
                        alias: 'introTransitionSkel',
                        src: 'assets/mobile/14_feature/transition/transition.skel',
                    },
                    {
                        alias: 'introTransitionAtlas',
                        src: 'assets/mobile/14_feature/transition/transition.atlas',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },


                    // Peek N Pounce
                    {
                        alias: 'Alphakind',
                        src: 'assets/mobile/11_font/pnp_intro_font/Alphakind.ttf',
                    },
                    {
                        alias: 'DejaVuSansMono',
                        src: 'assets/mobile/11_font/pnp_intro_font/DejaVuSansMono.ttf',
                    },
                    //Peek n Pounce 
                    // {
                    //     alias: 'pnp_win_amount',
                    //     src: 'assets/mobile/11_font/pnp_win_digit/win_amount-export.xml',
                    // },
                    //Peek n Pounce 
                    // {
                    //     alias: 'pnp_reel_muliplier',
                    //     src: 'assets/mobile/11_font/pnp_reel_multiplier/reel_multiplier.xml',
                    // },
                    // {
                    //     alias: 'pnp_multiplier',
                    //     src: 'assets/mobile/11_font/pnp_reel_multiplier/multiplier.xml'
                    // },
                    {
                        alias: 'PopWarner',
                        src: 'assets/mobile/11_font/pop-warner/Pop Warner.ttf'
                    },
                    {
                        alias: 'Bungee',
                        src: 'assets/desktop/11_font/pop-warner/Bungee-Regular.ttf'
                    },
                    //Skull Fiesta
                    {
                        alias: 'skull_coin_multiplier',
                        src: 'assets/mobile/11_font/skull_coin_multiplier/coin_multiplier.xml'
                    },
                    {
                        alias: 'skull_collect_multiplier',
                        src: 'assets/mobile/11_font/skull_collect_meter/meter_multiplier.xml'
                    },
                    {
                        alias: 'skull_win_digit',
                        src: 'assets/mobile/11_font/skull_win_digit/win_digit.xml'
                    },
                    {
                        alias: 'skull_coin_number',
                        src: 'assets/mobile/11_font/skull_coin_multiplier/coin_number.xml'
                    },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/mobile/13_sound/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/mobile/13_sound/ui/btn_spin.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        src: 'assets/mobile/13_sound/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/mobile/13_sound/base/Bg_Loop.mp3',
                    },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/mobile/13_sound/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'trail_sound',
                        src: 'assets/desktop/13_sound/freegame/multiplier_panel.mp3',
                    },
                    {
                        alias: 'scatter_landed',
                        src: 'assets/desktop/13_sound/freegame/scatter_landing.mp3',
                    },
                    {
                        alias: 'free_Game_Banner',
                        src: 'assets/mobile/13_sound/freegame/free_Game_Banner.mp3',
                    },
                    {
                        alias: 'Reawaken',
                        src: 'assets/mobile/13_sound/freegame/reawaken.mp3',
                    },
                    {
                        alias: 'Tombstone_highlighted',
                        src: 'assets/mobile/13_sound/freegame/tombstone_highlighted.mp3',
                    },
                    {
                        alias: 'left_tombstone_appears',
                        src: 'assets/mobile/13_sound/freegame/left_tombstone_appears.mp3',
                    },
                    {
                        alias: 'left_tombstone_vanishes',
                        src: 'assets/mobile/13_sound/freegame/left_tombstone_vanishes.mp3',
                    },
                    {
                        alias: 'higher_win',
                        src: 'assets/mobile/13_sound/freegame/higher_win.mp3',
                    },
                    {
                        alias: 'symbol_reveal',
                        src: 'assets/mobile/13_sound/freegame/symbol_reveal.mp3',
                    },
                    {
                        alias: 'total_win',
                        src: 'assets/mobile/13_sound/freegame/total_win.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/mobile/13_sound/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'Banner_ending',
                        src: 'assets/mobile/13_sound/freegame/free_Game_Banner_ending.mp3',
                    },
                    {
                        alias: 'RIP_symbol',
                        src: 'assets/mobile/13_sound/freegame/rip_symbol.mp3',
                    },
                    {
                        alias: 'RIP_reveal',
                        src: 'assets/mobile/13_sound/freegame/rip_reveal.mp3',
                    },
                    {
                        alias: 'reawaken_symbol',
                        src: 'assets/mobile/13_sound/freegame/reawaken_symbol.mp3',
                    },
                    {
                        alias: 'Common_Win',
                        src: 'assets/mobile/13_sound/freegame/common_win.mp3',
                    },
                    {
                        alias: 'Free_Spins_Added',
                        src: 'assets/mobile/13_sound/freegame/free_spins_added.mp3',
                    },
                    {
                        alias: 'Symbol_highlighted',
                        src: 'assets/mobile/13_sound/freegame/symbol_highlighted.mp3',
                    },
                    {
                        alias: 'Intro_transition',
                        src: 'assets/mobile/13_sound/gameloading/Intro_transition.mp3',
                    },

                    {
                        alias: 'reel_stop',
                        src: 'assets/mobile/13_sound/spin/reel_stop.mp3',
                    },
                    {
                        alias: 'reels_spinning',
                        src: 'assets/mobile/13_sound/spin/reels_spinning.mp3',
                    },
                    {
                        alias: 'wild_flashing',
                        src: 'assets/mobile/13_sound/spin/wild_flashing.mp3',
                    },
                    {
                        alias: 'Ending_transition',
                        src: 'assets/mobile/13_sound/gameloading/ending_transition.mp3',
                    },
                    // {
                    //     alias: 'Ballon_transition',
                    //     src: 'assets/mobile/13_sound/gameloading/balloons_transition.mp3',
                    // },
                    {
                        alias: 'bonus_effect_adding_to_meter',
                        src: 'assets/mobile/13_sound/spin/bonus_effect_adding_to_meter.mp3',
                    },
                    {
                        alias: 'scatter_land',
                        src: 'assets/mobile/13_sound/spin/scatter_reel_higlighted.mp3',
                    },
                    {
                        alias: 'scatter_anticipation_loop',
                        src: 'assets/mobile/13_sound/spin/scatter_reel_loop.mp3',
                    },
                    // {
                    //     alias: 'throughthefire_symbol_activation',
                    //     src: 'assets/mobile/13_sound/spin/throughthefire_symbol_activation.mp3',
                    // },
                    {
                        alias: 'symbol_win',
                        src: 'assets/mobile/13_sound/win/Win_Without_Multiplier.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/mobile/13_sound/win/Win_With_Multiplier.mp3',
                    },
                    // {
                    //     alias: 'wild_sound_effect',
                    //     src: 'assets/mobile/13_sound/win/wild_sound_effect.mp3',
                    // },
                    {
                        alias: 'win_loop',
                        src: 'assets/mobile/13_sound/bigwin/Win_Loop.mp3',
                    },
                    //WINS
                    {
                        alias: 'Big_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Big_Win_Transition.mp3',
                    },
                    {
                        alias: 'Mega_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Mega_Win_Transition.mp3',
                    },
                    {
                        alias: 'Super_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Super_Win_Transition.mp3',
                    },
                    {
                        alias: 'Epic_Win_Transition',
                        src: 'assets/mobile/13_sound/bigwin/Epic_Win_Transition.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/mobile/13_sound/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/mobile/13_sound/bigwin/Win_Count_up_End.mp3',
                    },
                ],
            },

        ],
    }
};

